import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: _ctx.previewHTML }, null, 8, _hoisted_1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      justify: "center",
      class: "mt-2 pb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          readonly: _ctx.currentSlide === 0,
          disabled: _ctx.currentSlide === 0,
          onClick: _ctx.goToPrevious,
          class: "mr-2 elevation-0",
          dark: "",
          rounded: "xl",
          small: "",
          variant: "flat",
          density: "compact"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Précédent ")
          ])),
          _: 1
        }, 8, ["readonly", "disabled", "onClick"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentSlide + 1) + " / " + _toDisplayString(_ctx.learningModule.learningObjects.length), 1),
        _createVNode(_component_v_btn, {
          readonly: _ctx.currentSlide === _ctx.learningModule.learningObjects.length - 1,
          disabled: _ctx.currentSlide === _ctx.learningModule.learningObjects.length - 1,
          onClick: _ctx.goToNext,
          class: "ml-2 elevation-0",
          dark: "",
          rounded: "xl",
          small: "",
          variant: "flat",
          density: "compact"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Suivant ")
          ])),
          _: 1
        }, 8, ["readonly", "disabled", "onClick"])
      ]),
      _: 1
    })
  ]))
}